import { VehicleAlarmNotificationForm } from "./VehicleAlarmNotificationForm"

export const VehicleAlarmNotificationBar = ({
  formData,
  editVehicleAlarmNotification,
  onSubmit,
  feedback,
  result,
  deleteNotificationSubmit,
  deleteResult
}) => {
  return (
    <>
      <VehicleAlarmNotificationForm
        formData={formData}
        onSubmit={onSubmit}
        editVehicleAlarmNotification={editVehicleAlarmNotification}
        feedback={feedback}
        result={result}
        deleteResult={deleteResult}
        deleteNotificationSubmit={deleteNotificationSubmit}
        id={formData?.id}
        deleteFeedback={feedback}
      />
    </>
  )
}
